import { now } from "common";
import { Experience, ScheduleType, Seller, Timeslot, WaitlistItem } from "types";
import { allowMultipleEventsPerTimeslot } from "./Experience";
import { getEquipmentRosterLineItems } from "./PurchaseItem";

// Equipment waitlists need available units per requested template, not just guest capacity.
const hasOpenCapacityForItem = (item: WaitlistItem, timeslot: Timeslot): boolean => {
    const equipmentLineItems = getEquipmentRosterLineItems(item);

    if (equipmentLineItems.length > 0) {
        return equipmentLineItems.every((lineItem) => {
            const unit = timeslot.units?.find((u) => u.template?.id === lineItem.template?.id);
            // Equipment books whole units, so compare against the unit count, not open seats.
            return (unit?.count ?? 0) >= (lineItem.quantity ?? 0);
        });
    }

    return (timeslot.capacity?.open ?? 0) >= item.quantity;
};

export const getCanInvite = (seller: Seller, timeslot: Timeslot, item: WaitlistItem, experience: Experience) => {
    const hasStarted = timeslot.arrivalDatetime.isBefore(now());
    const hasEnded = timeslot.end.isBefore(now());
    let hasSeatsAvailable = hasOpenCapacityForItem(item, timeslot) && item.quantity !== 0;

    // TODO: Fix once we refactor waitlists.
    const isItemPrivate = false;

    if (hasSeatsAvailable && isItemPrivate && !allowMultipleEventsPerTimeslot(seller, experience)) {
        hasSeatsAvailable = timeslot.capacity?.reserved === 0;
    }

    if (experience.scheduleType === ScheduleType.DAY) {
        return hasSeatsAvailable && !hasEnded;
    }

    return hasSeatsAvailable && !hasStarted;
};

export const getCanConfirm = (seller: Seller, timeslot: Timeslot, item: WaitlistItem, experience: Experience) => {
    const hasSeatsAvailable = hasOpenCapacityForItem(item, timeslot);

    // TODO: Fix once we refactor waitlists.
    const isItemPrivate = false;

    if (hasSeatsAvailable && isItemPrivate && !allowMultipleEventsPerTimeslot(seller, experience)) {
        return timeslot.capacity?.reserved === 0;
    }

    return hasSeatsAvailable;
};
